"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

var _ = _interopRequireWildcard(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _reselect = require("reselect");

var _TopicBadgeFilter = _interopRequireDefault(require("../../../components/resources/topics/TopicBadgeFilter"));

var _SearchPanel = _interopRequireDefault(require("../../../components/search/SearchPanel"));

var _Util = require("../../../components/util/Util");

var _article = require("../../../redux/article/article.types");

var _topic = require("../../../redux/topics/topic.types");

var selectors = _interopRequireWildcard(require("../../../redux/selectors"));

var _SwitchFilter = _interopRequireDefault(require("../../../components/filter/SwitchFilter"));

require("./resourceLandingPage.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Column
} = _table.default;
const {
  confirm
} = _modal.default;
const tableStyle = {
  background: '#FFF'
};
const initialState = {
  selectedTopicId: -1,
  selectedTopicIds: [],
  includeDeleted: false,
  isSearched: false
};

class ResourceList extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.handleSearchStringChange = event => {
      event.stopPropagation();
      const {
        loadArticles
      } = this.props;

      if (event.target.value.length === 0) {
        this.setState({
          isSearched: false
        });
        loadArticles({});
      }
    };

    this.handleSearchSubmit = value => {
      const {
        loadArticles
      } = this.props;
      this.setState({
        isSearched: true
      });
      loadArticles({
        query: value
      });
    };

    this.handleAddResourceClick = event => {
      event.stopPropagation();
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/resources/new`);
    };

    this.handleSelectedTopicsChanged = selectedTopicIds => {
      this.setState({
        selectedTopicIds
      });
    };

    this.deleteArticle = articleId => {
      const {
        deleteArticle
      } = this.props;
      confirm({
        title: 'Are you sure you want to delete this activity?',
        okText: 'Delete',
        okType: 'danger',

        onOk() {
          deleteArticle(articleId);
        },

        onCancel() {}

      });
    };

    this.copyDeepLink = id => {
      const deepLink = `hmp://resource/${id}`;
      navigator.clipboard.writeText(deepLink).then(() => {
        _message2.default.success('Copied to clipboard!');
      }, () => {
        _message2.default.error('Failed to copy to clipboard.');
      });
    };

    this.publishArticle = id => {
      const {
        publishArticle
      } = this.props;
      publishArticle({
        id
      });
    };

    this.unpublishArticle = id => {
      const {
        unpublishArticle
      } = this.props;
      unpublishArticle(id);
    };

    this.rowClassName = (record, index) => {
      return `${index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color'} hmp-clickable-row`;
    };

    this.renderActions = article => {
      const displayDeleteAction = article.deleteDate === null;
      const displayPublish = article.publishDate === null;
      const articleId = article.id || -1;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "resources-action-container"
      }, displayDeleteAction && /*#__PURE__*/_react.default.createElement("a", {
        title: "Delete",
        className: "resource-action",
        onClick: e => {
          e.stopPropagation();
          this.deleteArticle(articleId);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-trash-alt fa-lg"
      })), /*#__PURE__*/_react.default.createElement("a", {
        title: "Copy deep link to clipboard",
        className: "resource-action",
        onClick: e => {
          e.stopPropagation();
          this.copyDeepLink(articleId);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "far fa-link fa-lg"
      })), displayPublish ? /*#__PURE__*/_react.default.createElement("a", {
        title: "Publish",
        className: "resource-action",
        onClick: e => {
          e.stopPropagation();
          this.publishArticle(articleId);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-calendar-plus fa-lg"
      })) : /*#__PURE__*/_react.default.createElement("a", {
        title: "Unpublish",
        className: "resource-action",
        onClick: e => {
          e.stopPropagation();
          this.unpublishArticle(articleId);
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "fal fa-calendar-times fa-lg"
      })));
    };

    this.toggleIncludeDeleted = includeDeleted => {
      this.setState({
        includeDeleted
      });
    };

    this.stringAsDateSorter = (a, b) => {
      if (!a && !b) return 0;
      if (a === undefined) return -1;
      if (b === undefined) return 1;
      if (a === null) return -1;
      if (b === null) return 1;
      return (0, _moment.default)(a).unix() - (0, _moment.default)(b).unix();
    };

    this.onRow = row => {
      const {
        history,
        studyId
      } = this.props;
      return {
        onClick: event => {
          event.stopPropagation();
          history.push(`/study/${studyId}/resources/edit/${row.id}`);
        }
      };
    };

    this.renderCover = (coverUrl, row) => {
      if (coverUrl) {
        return /*#__PURE__*/_react.default.createElement("img", {
          alt: `${row.title} cover image`,
          src: coverUrl,
          width: "100px"
        });
      }
    };

    this.renderTopicLabel = topicId => {
      const {
        resourceTopics
      } = this.props;

      if (!resourceTopics) {
        return 'UNKNOWN';
      }

      for (const topic of resourceTopics) {
        if (topic.id === topicId) {
          return topic.title;
        }

        if (topic.children && topic.children.length > 0) {
          for (const child of topic.children) {
            if (child.id === topicId) {
              return `${topic.title} : ${child.title}`;
            }
          }
        }
      }
    };

    this.caseInsensitiveTextSorter = (a, b) => {
      if (a === undefined) return 1;
      if (b === undefined) return -1;
      if (a === null) return 1;
      if (b === null) return -1;
      return a.toLowerCase().localeCompare(b.toLowerCase());
    };

    this.titleSorter = (a, b) => this.caseInsensitiveTextSorter(a.title, b.title);

    this.summarySorter = (a, b) => this.caseInsensitiveTextSorter(a.summary, b.summary); //   topicSorter = (a: ArticleType, b: ArticleType) =>
    //     this.caseInsensitiveTextSorter(
    //       a.topic ? a.topic.title : null,
    //       b.topic ? b.topic.title : null
    //     );


    this.createDateSorter = (a, b) => this.stringAsDateSorter(a.createDate, b.createDate);

    this.publishDateSorter = (a, b) => this.stringAsDateSorter(a.publishDate, b.publishDate);

    this.lastUpdateDateSorter = (a, b) => this.stringAsDateSorter(a.lastUpdateDate, b.lastUpdateDate);

    this.deleteDateSorter = (a, b) => this.stringAsDateSorter(a.deleteDate, b.deleteDate);
  }

  componentDidMount() {
    const {
      loadResourceTopics,
      loadArticles
    } = this.props;
    loadResourceTopics();
    loadArticles({
      includeDeleted: true,
      includeUnpublished: true
    });
  }

  render() {
    const {
      loadResourceTopicsStatus,
      resourceTopics,
      selectedArticles
    } = this.props;
    const {
      selectedTopicIds,
      includeDeleted,
      isSearched
    } = this.state;

    if (loadResourceTopicsStatus.isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Loading Resources");
    }

    if (loadResourceTopicsStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, "Error loading the resource topics:", ' ', loadResourceTopicsStatus.errorMessage);
    }

    if (resourceTopics === undefined) {
      return /*#__PURE__*/_react.default.createElement("div", null, "No Resource Topics are defined; by default UNKNOWN should at least be loaded.");
    }

    const filteredArticles = _.filter(selectedArticles, article => {
      if (article.deleteDate) return false || includeDeleted;

      if (selectedTopicIds === null || selectedTopicIds === void 0 ? void 0 : selectedTopicIds.length) {
        return !!_.find(selectedTopicIds, id => article.topicId === id);
      }

      return true;
    });

    return /*#__PURE__*/_react.default.createElement(_card.default, {
      title: /*#__PURE__*/_react.default.createElement("div", {
        className: "resources-title"
      }, /*#__PURE__*/_react.default.createElement("h1", null, "Resources"), /*#__PURE__*/_react.default.createElement(_button.default, {
        type: "primary",
        onClick: this.handleAddResourceClick
      }, "+ Add Resource"))
    }, /*#__PURE__*/_react.default.createElement(_SearchPanel.default, {
      filters: [/*#__PURE__*/_react.default.createElement(_TopicBadgeFilter.default, {
        topics: resourceTopics,
        selectedTopicsChanged: this.handleSelectedTopicsChanged
      }), /*#__PURE__*/_react.default.createElement(_SwitchFilter.default, {
        value: includeDeleted,
        label: "Show Deleted",
        onChange: this.toggleIncludeDeleted
      })],
      searchChangeHandler: this.handleSearchStringChange,
      searchSubmitHandler: this.handleSearchSubmit
    }), /*#__PURE__*/_react.default.createElement(_table.default, {
      pagination: false,
      dataSource: filteredArticles,
      rowKey: row => `row-${row.id}`,
      style: tableStyle,
      onRow: this.onRow,
      rowClassName: this.rowClassName,
      scroll: {
        y: 500
      },
      key: `resource-table-${isSearched}`
    }, /*#__PURE__*/_react.default.createElement(Column, {
      title: "ID",
      dataIndex: "id",
      key: "id"
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Cover",
      dataIndex: "cover",
      key: "cover",
      render: this.renderCover,
      width: "100"
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: this.titleSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Summary",
      dataIndex: "summary",
      key: "summary",
      sorter: this.summarySorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Topic",
      dataIndex: "topicId",
      key: "topicId",
      render: this.renderTopicLabel,
      width: "240px"
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Create Date",
      dataIndex: "createDate",
      key: "createDate",
      render: _Util.renderDateCalendar,
      width: "120px",
      sorter: this.createDateSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Publish Date",
      dataIndex: "publishDate",
      key: "publishDate",
      render: _Util.renderDateCalendar,
      width: "120px",
      sorter: this.publishDateSorter
    }), /*#__PURE__*/_react.default.createElement(Column, {
      title: "Date Modified",
      dataIndex: "lastUpdateDate",
      key: "lastUpdateDate",
      render: _Util.renderDateCalendar,
      width: "120px",
      defaultSortOrder: isSearched ? undefined : 'descend',
      sorter: this.lastUpdateDateSorter
    }), includeDeleted ? /*#__PURE__*/_react.default.createElement(Column, {
      title: "Delete Date",
      dataIndex: "deleteDate",
      key: "deleteDate",
      render: _Util.renderDateCalendar,
      width: "120px",
      sorter: this.deleteDateSorter
    }) : undefined, /*#__PURE__*/_react.default.createElement(Column, {
      title: "Actions",
      render: this.renderActions
    })));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  loadResourceTopicsStatus: selectors.loadResourceTopicsStatus,
  studyId: selectors.getRequestedStudyId,
  resourceTopics: selectors.getResourceTopics,
  selectedArticles: selectors.getSelectedArticles
});

const mapDispatchToProps = dispatch => {
  return {
    loadResourceTopics: () => dispatch(_topic.loadResourceTopicsAsync.request()),
    loadArticles: param => dispatch(_article.loadArticlesAsync.request(param)),
    deleteArticle: resourceId => dispatch(_article.deleteArticleAsync.request(resourceId)),
    publishArticle: args => dispatch(_article.publishArticleAsync.request(args)),
    unpublishArticle: id => dispatch(_article.unpublishArticleAsync.request(id))
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ResourceList));

exports.default = _default;